import { completeName, uppercaseInitials } from 'utils';

export const normalizeDataWarehouse = (payload: any) => {
  const data = payload?.data?.item;
  return data ? {
    ...data,
    name: completeName(data.firstName, data.middleName, data.lastName),
    initialsName: uppercaseInitials(data.firstName, data.middleName, data.lastName),
  } : null;
};